"use strict";

module.exports = function orderedSetParser(input) {
  return new Set(input.split(/\s+/).filter(Boolean));
};



//////////////////
// WEBPACK FOOTER
// ./~/jsdom/lib/jsdom/living/helpers/ordered-set-parser.js
// module id = 1517
// module chunks = 0